var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ranking-table',{attrs:{"file":'asset/files/' + _vm.$route.query.name + '.json',"modal":_vm.modal,"fields":_vm.fields,"backButton":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }